<!-- <div class="guest-data">
  <div for="" class="page-title guest-data__page-title">{{'reservationDetails'| translate}}</div>  
  <div class="guest-data__reservation-data content-summary">
    <div style="width: 100%;">
      <span class="guest-data__guest-info-text"
        *ngIf="partyDetails.specialMeal && partyDetails.specialMeal.Name">{{partyDetails.specialMeal.Name}}
        <span *ngIf="paymentData && paymentData.SpecialMealAmountinfo && paymentData.SpecialMealAmountinfo >0">-
          {{paymentData.OperationCurrency}}{{paymentData.SpecialMealAmountinfo}}</span></span>
      <span class="guest-data__guest-info-text">{{partyDetails.partySize}} Party</span>
      <span class="guest-data__guest-info-text">{{partyDetails.reservationTime | date:'dd/MM/yyyy'}}</span>
      <span class="guest-data__guest-info-text">{{partyDetails.reservationTime| date:'h:mm a'}}</span>
      <span class="guest-data__guest-info-text"
        *ngIf="partyDetails.seatingType && partyDetails.seatingType.name">{{partyDetails.seatingType.name}}
        <span *ngIf="paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0">-
          {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo}}</span>
      </span>
      <span class="guest-data__guest-info-text"
        *ngIf="paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0">-
        {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo}}</span>
    </div>
    <div style="padding: 0 12px;">
      <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
    </div>
  </div>

  <div class="guest-data__guest-data">
    <ng-scrollbar>
    <div class="guest-data__guest-info" *ngFor="let guest of guestData">
      <div for="" class="section-header guest-data__guest-title">{{guest | translate}}</div>
      <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
      </dynamic-form>
    </div>
    <div style="display: flex;flex-direction: column;" *ngIf="noShowfee >0 && !rs.additionalGuestPage">
      <span class="default-sub-header" style="
        padding-bottom: 8px;margin-top: 16px;
    ">{{'noShowPolicy' | translate}}</span>
      <div class="default-form-field mb-0" style="    background: #f7f7f7;
        padding: 15px;
        border-radius: 4px;width: 560px;">
        <span>No Show Cancellation Fee : {{paymentData.OperationCurrency}}{{noShowfee}}</span>
        <p class="" style="    padding-top: 8px;
        margin-bottom: 0;">
          {{noShowfeeMessage}}
        </p>
      </div>
    </div>
    <div style="display: flex;flex-direction: column;" *ngIf="activityPayment>0 && !rs.additionalGuestPage">
      <span class="default-sub-header" style="
        padding-bottom: 8px;margin-top: 16px;
    ">Pre Payment Policy</span>
      <div class="default-form-field mb-0" style="    background: #f7f7f7;
        padding: 15px;
        border-radius: 4px;width: 560px;">
        <span>Payment : {{paymentData.OperationCurrency}}{{activityPayment}}</span>
        <p class="" style="    padding-top: 8px;
        margin-bottom: 0;">
          {{paymentMessage}}
        </p>
      </div>
    </div>
  </ng-scrollbar>
  </div>
  <app-button 
    [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
  <div class="guest-data__actions">
    <app-button [buttontype]="previousButton" (valueChange)="getSeatSelection()"></app-button>
    <app-button [buttontype]="confirmButton" (valueChange)="reservationConfirm()"></app-button>
  </div>
  <div *ngIf="showIframe"><iframe width="100%" height="700px" frameBorder="0" [src]="urlSafe"></iframe></div>
</div> -->



<div class="guest-data">
  <div class="guest-data__header-container" *ngIf="TotalAmount || !gs.restaurantWidgetSettings$.value.IsCartEnabled">
    <div class="guest-data__amount-container">
      <div class="guest-data__amount-payable-header" *ngIf="TotalAmount">{{'TotalPayableAmount' | translate}}&nbsp;:
      </div>
      <div class="guest-data__amount-payable" *ngIf="TotalAmount">
        &nbsp;{{gs.restaurantWidgetSettings$.value.OperationCurrency}}{{TotalAmount | currencyDecimalFormatter }}</div>
    </div>
    <div class="guest-data__time-container"
      *ngIf="!gs.restaurantWidgetSettings$.value.IsCartEnabled || gs.operation != operationType.create">
      <div class="focused-sub-header  guest-data__time-mins"
        [ngStyle]="gs.minutes === 0 && gs.seconds < 60 ?  {'color':'#f5e205'} : {'color':'#05f5f5'}"><span
          class="guest-data__timer-number">{{gs.minutes}}</span>
        <span class="error-message">{{'mins' | translate}}</span> <span
          class="guest-data__timer-number">{{gs.seconds}}</span> <span class="error-message">{{'secs' |
          translate}}</span>
      </div>
      <div class="guest-data__time-left-text">{{'leftForBooking' | translate}}</div>
    </div>
  </div>

  <div for="" class="page-title guest-data__page-title"
    *ngIf="gs.operation==operationType.create && !gs.additionalGuestPage">
    {{'reservationDetails'| translate}}</div>
  <div for="" class="page-title guest-data__page-title" *ngIf="gs.operation==operationType.edit">
    {{'ModifiedReservationDetails' | translate}}</div>
  <!-- <div class="guest-data__remaining-time-indicator" *ngIf="gs.showTimer">

  </div> -->
  <!-- <div class="guest-data__reservation-data content-summary" [ngStyle]="{'background-color':gs.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor}">
      <div style="width: 100%;">
        <span class="guest-data__guest-info-text"
          *ngIf="partyDetails.specialMeal && partyDetails.specialMeal.Name">{{partyDetails.specialMeal.Name}}
          <span *ngIf="specialMealAmountInfo >0">-
            {{paymentData.OperationCurrency}}{{specialMealAmountInfo}}</span></span>
        <span class="guest-data__guest-info-text">{{partyDetails.partySize}} Party</span>
        <span class="guest-data__guest-info-text">{{partyDetails.reservationTime | date:'dd/MM/yyyy'}}</span>
        <span class="guest-data__guest-info-text">{{partyDetails.reservationTime| date:'h:mm a'}}</span>
        <span class="guest-data__guest-info-text"
          *ngIf="partyDetails.seatingType && partyDetails.seatingType.name">{{partyDetails.seatingType.name}}
          <span *ngIf="ratePlanAmountInfo >0">-
            {{paymentData.OperationCurrency}}{{ratePlanAmountInfo}}</span>
        </span>
        <span class="guest-data__guest-info-text"
          *ngIf="!(ratePlanAmountInfo >0) && !(specialMealAmountInfo>0) && noShowfee >0 ">{{ 'amount' | translate}}
          {{paymentData.OperationCurrency}}{{noShowfee}}</span>
      </div>
      <div style="padding: 0 12px;">
        <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
      </div>
    </div> -->
  <div class="guest-data__guest-section">
    <!-- <ng-scrollbar> -->
    <!--Needed -->

    <!-- have to check -->
    <div class="guest-data__guest-data">
      <div class="guest-data__admin-msgs"
        *ngIf="this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage">
        <i class="icon-Info guest-data__info-icon"></i>
        {{this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PreReservationMessage}}
      </div>
      <div class="guest-data__guest-info" *ngFor="let guest of guestData;let i=index;trackBy:trackByGuest"
        [ngStyle]="{'background-color':gs.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
        <div for="" class="section-header guest-data__guest-title">{{guest.name | translate}}
          <i *ngIf="gs.operation == operationType.edit && i!=0" class="icon-DeleteWidget guest-data__delete-icon"
            (click)="openDeleteConfirmationPopUp(i)"></i>
        </div>
        <div class="guest-data__member-info" *ngIf="gs.additionalGuestPage || i != 0" [hidden]="!guest.isNew">
          <dynamic-form [config]="membershipConfig" #memberForm="dynamicForm">
          </dynamic-form>
        </div>
        <div *ngIf="gs.operation != operationType.edit || (gs.operation == operationType.edit && i == 0)">
          <dynamic-form [config]="guestInfoConfig" #form="dynamicForm">
          </dynamic-form>
        </div>
        <div *ngIf="gs.operation == operationType.edit && i != 0">
          <dynamic-form [config]="guestInfoConfigSecondary" #form="dynamicForm">
          </dynamic-form>
        </div>
        <ng-container *ngIf="cancellationPolicy">
          <div class="guest-data__cancellation-policy-title">{{'cancellationPolicy'| translate}}:</div>
          <div class="guest-data__cancellation-policy">
            {{cancellationPolicy}}
          </div>
        </ng-container>

      </div>
      <div class="guest-data__iframe-view"
        *ngIf="urlSafe && !gs.editFromCart && (!gs.restaurantWidgetSettings$.value.IsCartEnabled || gs.operation != operationType.create || waiverForm)">
        <iframe width="560px" height="650px" frameBorder="0" [src]="urlSafe"></iframe>
      </div>
      <div style="display: flex;flex-direction: column;"
        *ngIf="activityPayment>0 && !rs.additionalGuestPage && gs.operation==operationType.create">
        <span class="default-sub-header" style="
          padding-bottom: 8px;margin-top: 16px;
      ">Pre Payment Policy</span>
        <div class="default-form-field mb-0" style="    background: #f7f7f7;
          padding: 15px;
          border-radius: 4px;width: 560px;">
          <span>Payment : {{paymentData.OperationCurrency}}{{activityPayment | currencyDecimalFormatter}}</span>
          <p class="" style="    padding-top: 8px;
          margin-bottom: 0;">
            {{paymentMessage}}
          </p>
        </div>
      </div>
    </div>

    
    <div class="guest-data__actions">
      <div class="d-inline-block">
        <app-button
        *ngIf="((gs.additionalGuestPage  && (gs.additionalGuestRequired) > guestData.length)|| (gs.operation == operationType.edit && !gs.editFromCart && (gs.additionalGuestLength > guestData.length))) && gs.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails"
        [buttontype]="additionalGuestBtn" (valueChange)="additionalGuest()"></app-button>
      </div>
      <div class="d-inline-block">
        <app-button *ngIf="gs.additionalGuestPage" [buttontype]="backButton" (valueChange)="backtosummary()">
        </app-button>
      </div>
      <div class="d-inline-block">
        <app-button *ngIf="!gs.additionalGuestPage" [buttontype]="previousButton" (valueChange)="getSeatSelection()">
        </app-button>
      </div>
      <div class="d-inline-block">
        <app-button *ngIf="(!gs.additionalGuestPage && (!gs.restaurantWidgetSettings$.value.IsCartEnabled)) || ( !gs.additionalGuestPage  && gs.operation == operationType.edit && !gs.editFromCart )"
          [buttontype]="confirmButton" (valueChange)="reservationConfirm()">
        </app-button>
      </div>
      <div class="d-inline-block">
        <app-button
          *ngIf="!gs.additionalGuestPage && (gs.restaurantWidgetSettings$.value.IsCartEnabled && gs.operation == operationType.create)"
          [buttontype]="addToButton" (valueChange)="addToCartData()">
        </app-button>
      </div>
      <div class="d-inline-block">
        <app-button *ngIf="!gs.additionalGuestPage && gs.editFromCart" [buttontype]="bookBtn"
          (valueChange)="UpdateCart()">
        </app-button>
      </div>
      <div class="d-inline-block">
        <app-button *ngIf="gs.additionalGuestPage" [buttontype]="SaveGuestbtn"
          (valueChange)="createSecondaryContacts()">
        </app-button>
      </div>
    </div>
    <!-- </ng-scrollbar> -->
  </div>
</div>